import StockEditIcon from "@mui/icons-material/Edit";
import StockSaveIcon from "@mui/icons-material/Save";
import { fontSizes } from "healthex-common/sizes";
import styled from "styled-components";
import { HXButton } from "../HXButton";
import { HXTextField } from "../base.styles";
export const FormItem = styled.div `
    display: flex;
    align-items: center;
    padding: 5px 0px;
    font-size: ${fontSizes.SMALL};
    height: 35px;
`;
export const FormLabel = styled.div `
    width: 200px;
    font-weight: bold;
`;
export const Input = styled.div `
    vertical-align: middle;

    & ${HXTextField} {
        width: 300px;
    }
`;
export const ReadonlyText = styled.div ``;
export const EditIcon = styled(StockEditIcon) `
    margin-bottom: -2px;
    margin-right: 2px;
`;
export const ButtonArea = styled.div `
    display: flex;
    gap: 20px;
    margin-top: 10px;
`;
export const SaveButton = styled(HXButton) `
    padding-left: 20px;
    padding-right: 20px;
`;
export const SaveIcon = styled(StockSaveIcon) `
    font-size: ${fontSizes.STANDARD} !important;
`;
export const OrgLogoImage = styled.img `
    object-fit: contain;
    height: 40px;
    vertical-align: middle;
    margin-right: 5px;

    .fallback > & {
        display: none;
    }
`;
export const FallbackName = styled.div `
    display: none;

    font-size: ${fontSizes.MICRO};
    width: 60px;

    .fallback > & {
        display: block;
    }
`;
export const InitialUserFormSpacer = styled.div `
    height: 30px;
`;
export const VanitySubdomainInput = styled(Input) `
    display: flex;
    flex-direction: row;
    align-items: center;

    & ${HXTextField} {
        width: 200px;
    }
`;
export const VanitySubdomainSuffix = styled.div ``;
